import { Component, OnInit } from "@angular/core";
import { User } from "../../models/user";
import { Store } from "@ngrx/store";
import { UserActions } from "../../store/actions/user.actions";
import { AuthService } from "../../services/auth.service";
import { Router } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { environment } from "../../../environments/environment";
import { UserService } from "../../services/user.service";
import { ActionService } from "../../services/action.service";
import { ProgramArticleService } from "../../services/program-article.service";
import { ChannelService } from "../../services/channel.service";
import { SidenavService } from "../../services/sidenav.service";
import { SharedService } from "../../services/shared.service";
import { FiltersActions, FiltersStateInterface } from "../../store/actions/filters.actions";
import * as _ from "lodash";
import { Subscription } from "rxjs/Subscription";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  currentUser: User;
  envName: string;
  version: string;
  type: string;
  languageSearch: string;
  tooltipShow: boolean;
  headerMessage: string;

  imageTaiga: string;
  titleTab: string;
  filters: FiltersStateInterface;
  subscriptions: Subscription[];

  /**
   * Initialize variables
   * @param {Store<any>} store
   * @param {UserActions} userActions
   * @param {AuthService} authService
   * @param {Router} router
   * @param {AdminService} adminService
   * @param {FiltersActions} filtersActions
   */
  constructor(
    private store: Store<any>,
    private userActions: UserActions,
    private programArticleService: ProgramArticleService,
    private channelService: ChannelService,
    private userService: UserService,
    private actionService: ActionService,
    private authService: AuthService,
    private router: Router,
    public adminService: AdminService,
    public sidenavService: SidenavService,
    public sharedService: SharedService,
    private filtersActions: FiltersActions
  ) {
    this.envName = environment.name;
    this.tooltipShow = false;
    this.tooltipShow = false;
    this.imageTaiga = "assets/img/LogoTAIGAwhite.png";
    this.filters = null;
    this.subscriptions = [];

    /**
     * Load filters from filters store state
     */
    this.subscriptions.push(
      this.store
        .select("filtersState")
        .subscribe((filters: FiltersStateInterface) => {
          this.filters = _.cloneDeep(filters);
        })
    );

    /**
     * Get the user from the store and if he's logged, load the tabs
     */
    this.store.select("userState").subscribe((user: User) => {
      if (user) {
        this.currentUser = user;
      } else {
        this.currentUser = null;
      }
    });
  }

  ngOnInit() {
    this.onDocumentClick = this.onDocumentClick.bind(this);
    document.addEventListener("click", this.onDocumentClick);

    // get header message
    this.actionService.getHeaderMessage().subscribe((result) => {
      this.headerMessage = result.value;
    });
  }

  /**
   * Logout the user by erase him from the store and redirect him to the login page
   */
  logout() {
    this.authService.logout().subscribe(() => {
      // empty localstorage
      localStorage.clear();
      this.userActions.logoutUser();
      this.userService.stopKeepingSessionAlive();
      this.router.navigate(["/login"]);
    });
  }

  /**
   * Listen the language dropdown and apply the change to the user store
   * @param event
   */
  changeLanguage(event) {
    this.userActions.changeLanguage(event.value);

    // Update countries and broadcasting countries
    this.programArticleService
      .getBroadcastingCountries(
        parseInt(localStorage.getItem("current_language_id"))
      )
      .subscribe((countries) => {
        localStorage.setItem("countries", JSON.stringify(countries));
      });

    // Update user Channels
    this.channelService.getUserChannels(event.value).subscribe((channels) => {
      localStorage.setItem("channels", JSON.stringify(channels));
      let linearChannels = channels.filter(
        (c) => c.isMain
      );
      this.filters.channels = linearChannels;
      this.filtersActions.setFilters(this.filters);
    });
  }

  showTooltip() {
    this.tooltipShow = !this.tooltipShow;
    if (this.tooltipShow) {
      // set position of tooltip depending of element of button
      this.positionTooltip();
      document.getElementById("help-tooltip").style.visibility = "unset";
    } else {
      document.getElementById("help-tooltip").style.visibility = "hidden";
    }
  }

  changeDefaultLanguage() {
    this.userService
      .updateDefaultLanguage(
        this.currentUser.id,
        this.currentUser.currentLanguage.id
      )
      .subscribe(() => {
        this.currentUser.languages.map((item) => (item.isDefault = false));
        this.currentUser.currentLanguage.isDefault = true;
      });
  }

  getOffset(element: any) {
    var _x = 0;
    var _y = 0;
    while (element && !isNaN(element.offsetLeft) && !isNaN(element.offsetTop)) {
      _x += element.offsetLeft - element.scrollLeft;
      _y += element.offsetTop - element.scrollTop;
      element = element.offsetParent;
    }
    return { top: _y, left: _x };
  }

  onResize() {
    this.positionTooltip();
  }

  positionTooltip() {
    // set position of tooltip depending of element of button
    var position = this.getOffset(document.getElementById("help-icon"));
    var element = document.getElementById("help-tooltip");
    if (element) {
      element.style.top = position.top + 50 + "px";
      element.style.left = position.left - 155 + "px";
    }
  }

  onDocumentClick(event) {
    if (event.target.id === "help-tooltip" || event.target.id === "help-icon") {
      return;
    }
    if (document.getElementById("help-tooltip")) {
      this.tooltipShow = false;
      document.getElementById("help-tooltip").style.visibility = "hidden";
    }
  }

  closeBanner() {
    this.sharedService.closeBannerVisibility();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/header/header.component.ts